import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import ContactForm from '../components/ContactForm';
const ContactPage = () => {
  return <div className="w-full" data-id="element-375">
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-24" data-id="element-376">
        <div className="absolute inset-0 bg-black opacity-60" data-id="element-377"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
        backgroundBlendMode: 'overlay'
      }} data-id="element-378"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-379">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-380">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-381">
            Get in touch with our team to discuss your engineering needs or
            request a quote.
          </p>
        </div>
      </section>
      {/* Contact Information Section */}
      <section className="py-16 bg-gray-50" data-id="element-382">
        <div className="container mx-auto px-4" data-id="element-383">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-384">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center" data-id="element-385">
              <div className="bg-red-600 text-white p-3 rounded-full w-14 h-14 flex items-center justify-center mx-auto mb-4" data-id="element-386">
                <PhoneIcon size={24} data-id="element-387" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-388">Phone</h3>
              <p className="text-gray-600" data-id="element-389">+256 123 456 789</p>
              <p className="text-gray-600" data-id="element-390">+256 987 654 321</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center" data-id="element-391">
              <div className="bg-red-600 text-white p-3 rounded-full w-14 h-14 flex items-center justify-center mx-auto mb-4" data-id="element-392">
                <MailIcon size={24} data-id="element-393" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-394">Email</h3>
              <p className="text-gray-600" data-id="element-395">info@daplamba.com</p>
              <p className="text-gray-600" data-id="element-396">support@daplamba.com</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center" data-id="element-397">
              <div className="bg-red-600 text-white p-3 rounded-full w-14 h-14 flex items-center justify-center mx-auto mb-4" data-id="element-398">
                <MapPinIcon size={24} data-id="element-399" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-400">Location</h3>
              <p className="text-gray-600" data-id="element-401">123 Engineering Avenue</p>
              <p className="text-gray-600" data-id="element-402">Kampala, Uganda</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center" data-id="element-403">
              <div className="bg-red-600 text-white p-3 rounded-full w-14 h-14 flex items-center justify-center mx-auto mb-4" data-id="element-404">
                <ClockIcon size={24} data-id="element-405" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-406">Working Hours</h3>
              <p className="text-gray-600" data-id="element-407">Monday - Friday: 8AM - 6PM</p>
              <p className="text-gray-600" data-id="element-408">Saturday: 9AM - 1PM</p>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Form and Map Section */}
      <section className="py-16" data-id="element-409">
        <div className="container mx-auto px-4" data-id="element-410">
          <div className="text-center mb-12" data-id="element-411">
            <h2 className="text-3xl font-bold mb-4" data-id="element-412">
              <span className="border-b-4 border-red-600 pb-2" data-id="element-413">Get</span> In
              Touch
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-414">
              Fill out the form below to inquire about our services or request a
              quote. Our team will get back to you as soon as possible.
            </p>
          </div>
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-415">
            <div className="lg:w-1/2" data-id="element-416">
              <ContactForm data-id="element-417" />
            </div>
            <div className="lg:w-1/2" data-id="element-418">
              <div className="h-full min-h-[400px] bg-gray-200 rounded-lg overflow-hidden" data-id="element-419">
                {/* Google Maps would be embedded here in a real website */}
                <div className="w-full h-full flex items-center justify-center" data-id="element-420">
                  <p className="text-gray-600" data-id="element-421">Google Maps Embed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white" data-id="element-422">
        <div className="container mx-auto px-4 text-center" data-id="element-423">
          <h2 className="text-3xl font-bold mb-6" data-id="element-424">
            Let's Work Together on Your Next Project
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-425">
            Whether you need a fire protection system, HVAC solution, or any
            other engineering service, our team is ready to deliver excellence.
          </p>
          <a href="tel:+256123456789" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-md font-medium transition-colors inline-block" data-id="element-426">
            Call Us Today
          </a>
        </div>
      </section>
    </div>;
};
export default ContactPage;